import React from 'react'

const Flows = () => {
  return (
    <div>
      <p>flows</p>
    </div>
  )
}

export default Flows
